export { SideIllustration } from './side-illustration';
